import { render, staticRenderFns } from "./insureBeginNotice.vue?vue&type=template&id=89e972f0&scoped=true&"
import script from "./insureBeginNotice.vue?vue&type=script&lang=js&"
export * from "./insureBeginNotice.vue?vue&type=script&lang=js&"
import style0 from "./insureBeginNotice.vue?vue&type=style&index=0&id=89e972f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e972f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e972f0')) {
      api.createRecord('89e972f0', component.options)
    } else {
      api.reload('89e972f0', component.options)
    }
    module.hot.accept("./insureBeginNotice.vue?vue&type=template&id=89e972f0&scoped=true&", function () {
      api.rerender('89e972f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/insureBeginNotice.vue"
export default component.exports